import React from 'react';
import Text, { TextVariant } from '@ui/Text/Text';
import TextBlock from '@ui/Text/TextBlock';

type UnicaseProps = {
  content?: string | null;
  isPill?: boolean | null;
};

export default function Unicase({ content, isPill }: UnicaseProps) {
  if (isPill && content) {
    return (
      <TextBlock variant={TextVariant.TextUnicase}>
        <span className="text-foreground bg-tertiary-foreground rounded-full px-3 py-1">{content}</span>
      </TextBlock>
    );
  }

  return <Text content={content} variant={TextVariant.TextUnicase} />;
}
